import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NotFound from 'containers/NotFound';
import Template from 'components/Template/Template.component';
import Preview from 'components/Preview/Preview.component';
import Dashboard from 'components/Dashboard/Dashboard.component';
import ScrollToTop from './ScrollToTop';
import { CustomDatasetJoyride } from 'components/Template/custom-template/ftux';
import ReportSettings from 'components/ReportSettings/ReportSettings.component';
import { ChannelProfileContext, UserPortalContext } from 'context/appcontext';
import { CDTourFlag } from 'constants/constant';

const CPRoutes = () => {
	const portalUserContext = React.useContext(UserPortalContext);
	const [cpUserProfile, setCpUserProfile] = useState(undefined);
	const CDTourEnabled = localStorage.getItem(CDTourFlag) !== 'true';

	const routesComponent = portalUserContext ? (
		<BrowserRouter basename="reportbuilder">
			<ScrollToTop />
			{/* Custom dataset Tour guide */}
			{CDTourEnabled && <CustomDatasetJoyride />}
			<ChannelProfileContext.Provider
				value={{ cpUserProfileContext: [cpUserProfile, setCpUserProfile] }}>
				<Routes>
					<Route path="/" element={<Dashboard />}></Route>
					<Route path="/preview" element={<Preview />} />
					<Route path="/reports" element={<ReportSettings />} />
					<Route path="/rbtemplates" element={<Template />} />
					<Route path="*" element={<NotFound />} />
				</Routes>
			</ChannelProfileContext.Provider>
		</BrowserRouter>
	) : (
		<div>Login Failed</div>
	);

	return routesComponent;
};

export default CPRoutes;
